<!-- =========================================================================================
    File Name: VxTour.vue
    Description: Tour Component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <date-picker 
        :lang="lang"
        placeholder="시작일" 
        v-model="modelValue"
        value-type="format"
        :format="format"
        :clearable='true'
        :disabled-date="checkDate"
        @input="update"
        :inline="inline"
    />
</template>

<script>


export default{
    name: 'date-picker-box',
    props: {
        modelValue:{
            type:String,
            default: null
        },
        format:{
            default: 'YYYY-MM-DD'
        },
        placeholder:{
            default : null
        },
        disabledDates: {
            default:{to:null,from : null}
        },
        inline:{
            default : false
        },
    },
    data () {
        return{
            name : null,
            lang :{
                
                months: ["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월",],
                // MMM
                monthsShort: ["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월",],
                // dddd
                weekdays:["일", "월", "화", "수", "목", "금", "토"],
                // ddd
                weekdaysShort: ["일", "월", "화", "수", "목", "금", "토"],
                // dd
                weekdaysMin: ["일", "월", "화", "수", "목", "금", "토"],
                // first day of week
                firstDayOfWeek: 0,
                // first week contains January 1st.
                firstWeekContainsDate: 1,
                days: ["일", "월", "화", "수", "목", "금", "토"],
                months: ["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월",],
                yearFormat: "YYYY년",
                monthFormat: "MM월",
                // the calendar title of month before year
                monthBeforeYear: false,

            }
        }
    },
    watch: {
         
    },
    mounted () {
    },
    computed:{
        
    },
    methods:{
        checkDate(date){
            let condional1 = true,
                condional2 = true;
            if(this.disabledDates.to){
                let to = new Date(this.disabledDates.to)
                to.setHours(0,0,0,0)
                if( to >= date ){
                    condional1 = true
                }else{
                    condional1 = false
                }
            }else{
                condional1 = true
            }
            if(this.disabledDates.from){
                let from = new Date(this.disabledDates.from)
                from.setHours(0,0,0,0)
                if( from <= date ){
                    condional2 = true
                }else{
                    condional2 = false
                }
            }else{
                condional2 = true
            }
            
            return !(condional1&&condional2)
        },
        update( val){
            this.$emit('input',val )
            
        },
        
    }
}
</script>

<style lang="scss">

</style>
